function ErrorPage() {
  return (
    <>
      <h1>An error occurred!</h1>
    </>
  );
}

export default ErrorPage;